import React from 'react';
import _get from 'lodash/get';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import useSiteCopySelector from 'components/useSiteCopySelector';

const useStyles = makeStyles(theme => ({
  wrapper: {
    width: '100%',
    borderTop: '1px solid rgba(0,0,0,0.05)',
    borderBottom: '1px solid rgba(0,0,0,0.05)',
  },
  container: {
    paddingTop: 27,
    paddingBottom: 27,
    width: '80%',
    maxWidth: 1080,
    margin: 'auto',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      width: '90%',
      flexDirection: 'column',
      alignItems: 'flex-start',
      paddingTop: 30,
      paddingBottom: 30,
    },
  },
  itemWrapper: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      marginBottom: 30,
      '&:last-child': {
        marginBottom: 0,
      },
    },
  },
  icon: {
    marginRight: 10,
    height: 32,
    width: 32,
    color: '#01619B',
  },
  label: {
    fontFamily: 'PoppinsBold',
    fontWeight: '700',
    fontSize: 20,
    color: '#01619B',
    [theme.breakpoints.down('1150')]: {
      fontSize: 18,
    },
    [theme.breakpoints.down('1040')]: {
      fontSize: 16,
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: 20,
    },
  },
}));

function GoalsLine() {
  const classes = useStyles();
  const [solutionsSiteCopy] = useSiteCopySelector(['solutions-homepage']);
  const config = _get(solutionsSiteCopy, 'pageCopy.call-to-action-line', []);

  return (
    <section id="call-to-action-line">
      <div className={classes.wrapper}>
        <div className={classes.container}>
          {config.map(item => (
            <div className={classes.itemWrapper}>
              <Typography className={classes.label}>{item}</Typography>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default GoalsLine;
